export const componentIconType = {
  MATERIAL_ICON: 'material_icon',
  CUSTOM: 'custom'
}
